export const BASE_INTERVAL = 10;
export const BASE_LOG = Math.log(BASE_INTERVAL);

export type ExponentialRangeMarker = { value: number; label: number };

export type ExponentialRangeConfig = {
  min: number;
  max: number;
  markers: ExponentialRangeMarker[];
  toInternal: (value: number) => number;
  toExternal: (value: number) => number;
};

export const FILTER_ALIAS = {
  "f.custom.leafCategoryCodes": "category",
  "f.custom.statuses": "status",
  "f.price": "price",
  "f.brand": "brand",
  "f.designer": "designer",
  "f.custom.norce_color_group": "color",
} as const;

const ALIAS_TO_FILTER_PARAM: Record<string, string> = Object.fromEntries(
  Object.entries(FILTER_ALIAS).map(([param, alias]) => [alias, param]),
);

export function toFilterParam(param: string) {
  if (param in FILTER_ALIAS) {
    return FILTER_ALIAS[param as keyof typeof FILTER_ALIAS];
  }
  return param;
}

export function fromFilterParam(param: string) {
  return ALIAS_TO_FILTER_PARAM[param] ?? param;
}

export function isFilterParam(param: string) {
  return param.startsWith("f.") || param in ALIAS_TO_FILTER_PARAM;
}
